import countries from '@/data/countries';
import genres from '@/data/genres';
import { streamingUrl } from '@/utils/discovery';

const countryCodes = new Set(countries.map(country => country.code));
const text = value => typeof value === 'string' ? value.trim() : '';
export function catalogQuery(query) {
  const country = text(query.country).toUpperCase();
  const genre = text(query.genre);
  const page = Number(text(query.page));
  return {
    search: text(query.search),
    country: countryCodes.has(country) ? country : '',
    genre: Object.hasOwn(genres, genre) ? genre : '',
    sort: ['followers', 'newest', 'oldest'].includes(query.sort) ? query.sort : 'followers',
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
  };
}
export function artistProfileUrl(artist) {
  return typeof artist?.key === 'string' && artist.key ? `https://indiefy.me/${encodeURIComponent(artist.key)}?source=catalog` : '';
}
export function artistInitials(name = '') {
  const words = String(name).trim().split(/\s+/).filter(Boolean);
  return words.length > 1 ? words.slice(0, 2).map(word => Array.from(word)[0]).join('').toUpperCase() : Array.from(words[0] || '').slice(0, 2).join('').toUpperCase();
}
export function artistTone(artist) {
  return [...String(artist.main_genre || artist.name || '')].reduce((sum, char) => sum + char.charCodeAt(0), 0) % 4;
}
export function artistLinks(artist) {
  const links = [['Spotify', artist.spotify], ['YouTube', artist.youtube], ['Instagram', artist.instagram], ['Facebook', artist.facebook], ['SoundCloud', artist.soundcloud], ['X', artist.twitter], ['website', artist.website]];
  return links.map(([label, raw]) => {
    let value = text(raw);
    if (label === 'Spotify' && /^spotify:artist:[A-Za-z0-9]+$/.test(value)) value = `https://open.spotify.com/artist/${value.split(':')[2]}`;
    if (value && !value.includes('://') && ['Instagram', 'Facebook', 'X'].includes(label) && /^@?[\w.]+$/.test(value)) {
      const host = { Instagram: 'www.instagram.com', Facebook: 'www.facebook.com', X: 'x.com' }[label];
      value = `https://${host}/${value.replace(/^@/, '')}`;
    }
    return { label, url: streamingUrl(value) };
  }).filter(link => link.url);
}
